import { Loader2 } from "lucide-react";

/** Fixed-size submit control — label/spinner swap via visibility only (no animated reflow). */
export function StableSubmitButton({ busy, idleLabel, busyLabel, disabled, testId, type = "submit" }) {
    return (
        <button
            type={type}
            disabled={disabled || busy}
            className="btn-neon auth-submit relative w-full rounded-md text-sm font-semibold"
            data-testid={testId}
        >
            <span className={`auth-submit__label ${busy ? "" : "is-visible"}`}>{idleLabel}</span>
            <span className={`auth-submit__busy ${busy ? "is-visible" : ""}`} aria-hidden={!busy}>
                <Loader2 className="h-4 w-4 shrink-0 animate-spin" />
                {busyLabel}
            </span>
        </button>
    );
}
